import data from './attrs/data'
import methods from './attrs/methods'
import mounted from './attrs/mounted'
import ViewIntro from '../../components/ViewIntro'
import Nfe from '../../components/Nfe/Index'

export default {
  name: 'SubscriptionDetails',
  data,
  methods,
  mounted,
  components: {
    ViewIntro,
    Nfe,
  },
}
